'use strict';

var _ = require('lodash');
var FiltersPanelController = function FiltersPanelController($scope, $rootScope, $q, analysisMetricService, dataRetrieverConstantsService, dataRetrieverService, BrushSelectionFilter, currentStateCriteriaService, SearchCriteriaRule, configurationService, optWeekReferenceService, filterPanelService, netSpillRateDataService, criteriaRuleDataService) {
  var config = require('../config/FiltersPanelConfig.json');
  var initialFilters;
  $scope.bookingsType = config.bookingsType;
  $scope.display = config.display;
  $scope.filterLabels = {
    serviceType: _.cloneDeep(config.serviceType),
    market: [],
    //filled dynamically
    viaPoints: [] //filled dynamically
  };
  $scope.selected = _.cloneDeep(config.defaultSelected);
  $scope.nonStop = config.nonStop;
  $scope.longestService = '';
  $scope.title = {
    services: ''
  };
  $scope.maxSelectableWeeks = configurationService.getROMMaxSelectAnalysisWeeks();
  $scope.unchangedPrimaryFilter = true;
  var defBookingType = analysisMetricService.getAnalysisMetric(dataRetrieverConstantsService.ROM_ANALYSIS_SCREEN).getDefault();
  setDefaultValues();
  $scope.$watch('selectedDisplay', function (newVal, oldVal) {
    if (newVal && oldVal && newVal.id !== oldVal.id) {
      sendChangePaxDisplayEvent();
    }
  });
  var customSearchCriteriaPromise = $q.defer();
  var customSearchCriteriaPromiseResolved = false;
  $scope.onSearchChangeEvent = function () {
    fillInMarketsFilter(getMarketLabels());
    setDefaultValues();
    initialFilters = _.cloneDeep($scope.selected);
    $scope.onUpdate();
  };
  function setDefaultValues() {
    $scope.selectedDisplay = config.defaultSelectedDisplay;
    $scope.selectedBookingType = defaultBookingType();
    $scope.selected.serviceType = _.cloneDeep(config.defaultSelected.serviceType);
  }
  function defaultBookingType() {
    return defBookingType === 'individualAndGrouped' ? ['individual', 'group'] : [defBookingType];
  }
  function sendChangePaxDisplayEvent() {
    $rootScope.$broadcast('filters-panel:displayChange', $scope.selectedDisplay);
  }
  $scope.retrievePrimaryFilterData = function () {
    return dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.ROM_ANALYSIS_SCREEN, dataRetrieverConstantsService.ROM_ANALYSIS_SKINNY_SERVICES_MODE).currentSortBy('optGroupWeek').currentSortOrder('DESC').retrieveComponentData('filter-filler');
  };
  function getMarketLabels() {
    var allMarkets = _.map(criteriaRuleDataService.getOperandData('Market', '=', 'multi'), 'value');
    var rules = currentStateCriteriaService.getSearchCriteria().rules;
    var equalCriteria = _.chain(rules).filter({
      criterion: 'Market',
      operator: '='
    });
    var notEqualCriteria = _.chain(rules).filter({
      criterion: 'Market',
      operator: '!='
    });

    //all selected markets
    var equalMarkets = equalCriteria.map('leftOperand').flatten().uniq().value();
    //all not selected markets
    var notEqualMarkets = _.xor(allMarkets, notEqualCriteria.map('leftOperand').flatten().uniq().value());
    //intersection of them
    return equalMarkets.length ? notEqualMarkets.length ? _.intersection(equalMarkets, notEqualMarkets) : equalMarkets : notEqualMarkets;
  }
  $scope.primaryFilterDataHandler = function (data) {
    $scope.oldSelected = _.assign({}, $scope.selected);
    if (!data.length) {
      return;
    }
    var reduced = reducedData(data);
    fillInOptWeeks(reduced);
    fillIn('cabin', reduced);
    fillIn('spos', reduced);
  };
  function reducedData(data) {
    var reduced = _.reduce(data, function (accumulator, element) {
      accumulator.optGroupWeek[element.optGroupWeek] = true;
      accumulator.spos[element.spos] = true;
      accumulator.cabin[element.cabin] = true;
      return accumulator;
    }, {
      optGroupWeek: {},
      spos: {},
      cabin: {}
    });
    reduced.oneRowOfData = _.first(data);
    return reduced;
  }
  function fillInOptWeeks(reduced) {
    var weeks = _.keys(reduced.optGroupWeek);
    if (weeks.length === 0) {
      var currentCriteriaRules = getSearchCriteriaRulesForOneMarketOnly($scope.selected.market);
      weeks = _.find(currentCriteriaRules, function (rule) {
        return _.isEqual(rule.field, 'optGroupWeek') || _.isEqual(rule.field, 'custom:strictDateComparison:optGroupWeek');
      }).leftOperand;
    }
    var optMultiComboData = _.transform(weeks, function (result, optWeek) {
      var dateAsArray = optWeek.split('-');
      var dateAsShortString = dateAsArray[1] + '/' + dateAsArray[2];
      result.push({
        dropdownVisibleValue: dateAsShortString,
        value: optWeek
      });
    }, []);
    var optMultiComboDataSelected = [];
    var optMultiComboDataLength = optMultiComboData.length;
    for (var idx = 0, i = 0; idx < optMultiComboDataLength && i < 4; ++idx, ++i) {
      optMultiComboDataSelected.push(optMultiComboData[idx].value);
    }
    $scope.filterLabels.optWeeks = optMultiComboData;
    if (!$scope.selected.optWeeks || !isEveryOptWeekSelectionPossible($scope.selected.optWeeks, optMultiComboData)) {
      $scope.selected.optWeeks = optMultiComboDataSelected;
    } else {
      $scope.selected.optWeeks = _.clone($scope.selected.optWeeks);
    }
  }
  function isEveryOptWeekSelectionPossible(selection, possibleFilters) {
    return _.every(selection.map(_.partial(_.set, {}, 'value')), _.partial(_.find, possibleFilters));
  }
  function fillIn(filterName, reduced) {
    var keys = _.keys(reduced[filterName]).sort();
    $scope.filterLabels[filterName] = _.transform(keys, function (result, field) {
      result.push({
        id: field,
        label: field
      });
    }, []);
    if (shouldUpdateFilter(reduced.oneRowOfData, $scope.selected[filterName], $scope.filterLabels[filterName])) {
      $scope.selected[filterName] = {
        id: reduced.oneRowOfData[filterName],
        label: reduced.oneRowOfData[filterName]
      };
    }
  }
  function shouldUpdateFilter(oneRowOfData, selected, filterLabels) {
    return oneRowOfData && _.isEmpty(selected) || !_.find(filterLabels, _.pick(selected, ['id']));
  }
  function fillInMarketsFilter(markets) {
    $scope.filterLabels.market = markets;
    $scope.selected.market = markets[0];
  }
  function setCustomSearchCriteria() {
    var dataRetrievers = dataRetrieverService.findDataRetrievers(dataRetrieverConstantsService.ROM_ANALYSIS_SCREEN);
    var currentCriteriaRules = getSearchCriteriaRulesForOneMarketOnly($scope.selected.market);
    if (customSearchCriteriaPromiseResolved) {
      _.forEach(dataRetrievers, function (dataRetriever) {
        dataRetriever.setCustomSearchCriteriaRules($q.when(currentCriteriaRules));
      });
    } else {
      customSearchCriteriaPromise.resolve(currentCriteriaRules);
      customSearchCriteriaPromiseResolved = true;
    }
  }
  function getSearchCriteriaRulesForOneMarketOnly(currentMarket) {
    var criteria = currentStateCriteriaService.getCriteriaWithFlowType($scope.getSelectedFlowType());
    return filterPanelService.getSearchCriteriaRulesForOneMarketOnly(criteria, currentMarket);
  }
  $scope.onUpdate = function () {
    $rootScope.$broadcast('collapsable-panel:collapse');
    $scope.nonStop = config.nonStop;
    setCustomSearchCriteria();
    $scope.unchangedPrimaryFilter = true;
    return $scope.retrievePrimaryFilterData().then($scope.primaryFilterDataHandler).then($scope.populateBrushFilters).then(optWeekReferenceService.startRetrievingOptWeekRefForRomAnalysisScreen).then(retrieveSecondaryFilterData).then(secondaryFilterDataHandler);
  };
  $scope.populateBrushFilters = function () {
    var sposFilter = _.get($scope, 'selected.spos.id');
    var cabinFilter = _.get($scope, 'selected.cabin.id');
    var optWeeksFilter = _.get($scope, 'selected.optWeeks');
    $scope.brushFilter = new BrushSelectionFilter('filter-component', [{
      spos: [sposFilter],
      cabinCode: [cabinFilter]
    }]);
    if (optWeeksFilter && optWeeksFilter.length) {
      $scope.brushFilter.filterArguments[0][0].optGroupWeek = $scope.selected.optWeeks;
    }
    dataRetrieverService.setBrushFilters($scope.brushFilter, $scope.screen);
    dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.ROM_ANALYSIS_SCREEN, dataRetrieverConstantsService.ROM_ANALYSIS_FLATTENED_SERVICES_MODE).brushFilters($scope.brushFilter);
  };
  $scope.onHideViaPoints = function () {
    selectNonStop();
    sendBrushFilterChangedEvent();
  };
  $scope.onHideServices = function () {
    selectNonStop();
    selectViaPoints();
    selectNonStop();
    sendBrushFilterChangedEvent();
  };
  $scope.onHideBookingType = function () {
    sendBrushFilterChangedEvent();
  };
  $scope.onHideServiceTypeHandler = function () {
    sendBrushFilterChangedEvent();
  };
  $scope.nonStopClickHandler = function () {
    selectViaPoints();
    sendBrushFilterChangedEvent();
  };
  $scope.isFilterValid = function () {
    return $scope.selected.serviceType !== undefined && $scope.selected.services !== undefined && $scope.selectedBookingType !== undefined;
  };
  $scope.updateButtonStateChange = function () {
    if (!$scope.oldSelected) {
      $scope.unchangedPrimaryFilter = true;
      return;
    }
    var criteria;
    var currentSelected;
    var oldSelection;
    var primaryFilters = ['market', 'cabin', 'spos', 'optWeeks'];
    $scope.unchangedPrimaryFilter = true;
    for (var i = 0; i < primaryFilters.length; i++) {
      criteria = primaryFilters[i];
      if (!$scope.selected[criteria]) {
        $scope.unchangedPrimaryFilter = true;
        return;
      }
      currentSelected = $scope.selected[criteria].id ? $scope.selected[criteria].id : $scope.selected[criteria];
      oldSelection = $scope.oldSelected[criteria].id ? $scope.oldSelected[criteria].id : $scope.oldSelected[criteria];
      if (currentSelected instanceof Array) {
        currentSelected = currentSelected.toString();
        oldSelection = oldSelection.toString();
      }
      if (currentSelected !== oldSelection) {
        $scope.unchangedPrimaryFilter = false;
        return;
      }
    }
  };
  function secondaryFilterDataHandler(dataToFillInComponents) {
    var services = _.map(dataToFillInComponents, 'service');
    fillInSecondaryFilters(services);
    sendBrushFilterChangedEvent();
    netSpillRateDataService.startRetrievingData();
  }
  function sendBrushFilterChangedEvent() {
    if (!$scope.isFilterValid()) {
      return;
    }
    var selectedServices = calculateEffectiveServices();
    var filterArguments = $scope.brushFilter.filterArguments[0][0];
    filterArguments.isCodeShare = $scope.selected.serviceType;
    filterArguments.isNonStop = $scope.nonStop ? [$scope.nonStop] : [];
    if (selectedServices.length > 0) {
      filterArguments.service = selectedServices;
    } else {
      delete filterArguments.service;
    }
    setMetric();
    $scope.brushFilterChanged($scope.brushFilter);
  }
  function setMetric() {
    var metric = $scope.selectedBookingType.length === 2 ? 'individualAndGrouped' : $scope.selectedBookingType[0];
    dataRetrieverService.updateMetricValues(metric, dataRetrieverConstantsService.ROM_ANALYSIS_SCREEN);
  }
  function calculateEffectiveServices() {
    var selectedServices = {};
    _.forEach($scope.selected.services, function (serviceName) {
      selectedServices[serviceName] = true;
    });
    _.forEach($scope.filterLabels.services, function (service) {
      if (selectedServices[service.value] && service.viaPoints.length > 0) {
        selectedServices[service.value] = _.intersection(service.viaPoints, $scope.selected.viaPoints).length > 0;
      }
    });
    return _.transform(selectedServices, function (result, value, key) {
      if (value) {
        result.push(key);
      }
    }, []);
  }
  function retrieveSecondaryFilterData() {
    return dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.ROM_ANALYSIS_SCREEN, dataRetrieverConstantsService.ROM_ANALYSIS_FLATTENED_SERVICES_MODE).localSortApplied().retrieveComponentData('filter-component');
  }
  function fillInSecondaryFilters(originalServices) {
    var services = _.uniq(originalServices);
    fillInServicesFilter(services);
    setServicesClass();
    fillInViaPointsFilter();
    selectViaPoints();
  }
  function fillInServicesFilter(services) {
    if (services.length === 0) {
      $scope.filterLabels.services = [];
      $scope.selected.services = [];
      return;
    }
    $scope.filterLabels.services = _.map(services, function (service) {
      return {
        selected: false,
        value: service,
        viaPoints: calculateViaPoints(service)
      };
    });
    $scope.selected.services = services;
  }
  function setServicesClass() {
    var maxLength = $scope.filterLabels.services.reduce(function (reduced, current) {
      return Math.max(reduced, current.value.length);
    }, 0);
    if (maxLength > 10) {
      $scope.longestService = 'longest-service-' + maxLength;
    }
  }
  function fillInViaPointsFilter() {
    var viaPoints = {};
    _.forEach($scope.filterLabels.services, function (service) {
      _.forEach(service.viaPoints, function (viaPoint) {
        viaPoints[viaPoint] = true;
      });
    });
    var keys = _.keys(viaPoints).sort();
    $scope.filterLabels.viaPoints = _.transform(keys, function (result, field) {
      result.push({
        value: field
      });
    }, []);
  }
  function selectViaPoints() {
    if (!$scope.nonStop) {
      var viaPoints = {};
      _.forEach($scope.filterLabels.services, function (service) {
        if (_.includes($scope.selected.services, service.value)) {
          _.forEach(service.viaPoints, function (viaPoint) {
            viaPoints[viaPoint] = true;
          });
        }
      });
      $scope.selected.viaPoints = _.keys(viaPoints).sort();
    } else {
      $scope.selected.viaPoints = [];
    }
  }
  function selectNonStop() {
    $scope.nonStop = _.isNil($scope.selected.viaPoints) || $scope.selected.viaPoints.length === 0;
    var viaPointsCounter = $scope.filterLabels.services.reduce(function (acc, current) {
      if ($scope.selected.services && $scope.selected.services.indexOf(current.value) !== -1) {
        return acc + current.viaPoints.length;
      } else {
        return acc;
      }
    }, 0);
    if (viaPointsCounter > 0) {
      $scope.nonStop = false;
    }
  }
  function calculateViaPoints(service) {
    var splitted = service.split('-');
    var airports = _.map(splitted, function (item) {
      return item.replace(/[\d\- ]/g, '');
    });
    return _.uniq(airports.slice(1, -1));
  }
  $scope.$on('rom-analysis-panel:searchPanelClosed', $scope.onSearchChangeEvent);
  $scope.$watch('selected.services', function (newVal) {
    if (Array.isArray(newVal)) {
      $scope.title.services = newVal.join(', ');
    }
  });
  function initCustomSearchCriteria() {
    var dataRetrievers = dataRetrieverService.findDataRetrievers(dataRetrieverConstantsService.ROM_ANALYSIS_SCREEN);
    _.forEach(dataRetrievers, function (dataRetriever) {
      dataRetriever.setCustomSearchCriteriaRules(customSearchCriteriaPromise.promise);
    });
    customSearchCriteriaPromiseResolved = false;
  }
  $scope.$on('rom-analysis-panel:resetFilters', function () {
    $scope.selected = _.cloneDeep(initialFilters);
    $scope.selectedDisplay = config.defaultSelectedDisplay;
    $scope.selectedBookingType = defaultBookingType();
    $scope.onUpdate();
  });
  initCustomSearchCriteria();
};
FiltersPanelController.$inject = ['$scope', '$rootScope', '$q', 'AnalysisMetricService', 'DataRetrieverConstantsService', 'DataRetrieverService', 'BrushSelectionFilterFactory', 'CurrentStateCriteriaService', 'SearchCriteriaRuleFactory', 'ConfigurationService', 'OptWeekReferenceService', 'FilterPanelService', 'NetSpillRateDataService', 'CriteriaRuleDataService'];
module.exports = FiltersPanelController;